import { DatePicker } from "@mantine/dates";
import _ from "lodash";

const ClientPiDatePicker = ({
  form,
  name,
  disabled = false,
  onChange,
  value: _ignoredValue,
  ...props
}) => {
  const rawValue = _.get(form.values, name);
  const value = rawValue ? new Date(rawValue) : null;

  return (
    <DatePicker
      {...props}
      value={value}
      disabled={disabled || !form.values.professionalInvestor}
      onChange={onChange}
    />
  );
};

export default ClientPiDatePicker;
